import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { canonicalUrl } from '@core/utils/canonical-host';
import { environment } from '@env/environment';

// Only the production build names an address; the other builds leave this out.
const canonical = canonicalUrl((environment as { canonicalHost?: string }).canonicalHost, window.location);

if (canonical) {
  window.location.replace(canonical);
} else {
  bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
}
